import { useEffect, useState } from "react";
import { BiArrowBack } from "react-icons/bi";
import { Link, useSearchParams } from "react-router-dom";
import paymentService from "../services/paymentService";

const BookingFailure = () => {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState(null);

  useEffect(() => {
    const updateFailedPayment = async () => {
      const paymentId = sessionStorage.getItem("pendingPaymentId");
      const errorMessage =
        searchParams.get("message") ||
        searchParams.get("errorCode") ||
        "Payment was cancelled or failed";

      setError(errorMessage);

      if (paymentId) {
        try {
          // Update payment status to failed in Firebase
          await paymentService.updateBKTPaymentStatus(paymentId, {
            status: "FAILED",
            transactionId: searchParams.get("transactionId") || "",
            authCode: "",
            referenceNumber: "",
          });
        } catch (err) {
          console.error("Error updating failed payment:", err);
        }

        // Don't remove from sessionStorage - user might retry
      }
    };

    updateFailedPayment();
  }, [searchParams]);

  return (
    <div className="min-h-screen flex-center-center bg-gray-50 dark:bg-gray-900">
      <div className="rounded-lg p-6 sm:p-8 bg-white border-2 border-red-200 dark:bg-card-dark dark:border-red-900 text-center max-w-[600px] w-[95%] shadow-xl">
        <div className="icon-box !w-16 !h-16 sm:!w-20 sm:!h-20 !bg-red-500 mx-auto text-white">
          <span className="text-4xl sm:text-5xl">✕</span>
        </div>

        <h1 className="text-3xl sm:text-4xl font-bold mt-4 text-red-600 dark:text-red-400">
          Payment Failed
        </h1>

        <p className="mt-4 text-gray-700 dark:text-gray-300 text-base sm:text-lg">
          {error ||
            "Your payment could not be processed. This may happen if the payment was cancelled or there was an issue with your card."}
        </p>

        <div className="mt-6 p-4 bg-red-50 dark:bg-red-900/20 rounded-xl border border-red-200 dark:border-red-800">
          <h3 className="font-bold text-red-900 dark:text-red-200 mb-2">
            What to do next:
          </h3>
          <ul className="text-left text-sm text-red-800 dark:text-red-300 space-y-1.5">
            <li>• Check your card details and try again</li>
            <li>• Ensure you have sufficient funds available</li>
            <li>• Contact your bank if the problem persists</li>
            <li>• Try a different payment card</li>
          </ul>
        </div>

        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/confirm-booking"
            className="px-6 py-3 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 font-semibold transition-colors"
          >
            Try Payment Again
          </Link>

          <Link
            to="/"
            className="px-6 py-3 bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600 font-semibold transition-colors flex items-center justify-center gap-2"
          >
            <BiArrowBack />
            <span>Go Back Home</span>
          </Link>
        </div>

        <p className="mt-6 text-xs text-gray-500 dark:text-gray-400">
          If you believe this is an error or if you were charged, please contact
          our support team.
        </p>
      </div>
    </div>
  );
};

export default BookingFailure;
